<template>
  <span><input type="text input-component" class="mb-2" v-model="response" @keyup="$emit('responseevent', {id: idx, response: response})"></span>
</template>

<script>
    export default {
        name: "InputComponent",
        props:{
            content: Object,
            idx: Number,
        },
        data(){
            return {
                response : null
            }
        }
    }
</script>

<style scoped>

</style>